import { createContext } from 'react';

const AffContext = createContext({
  aff: null,
  setAff: () => {},
  affId: null,
  setAffId: () => {},
});

export { AffContext };
